<div class="container">
    <div class="row justify-content-center login">
        <div class="col-xl-6 col-lg-6 col-md-9">
            <div class="card o-hidden border-0 shadow-lg my-5">
                <div class="card-body p-0">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="p-5">
                                <div class="text-center pt-4">
                                    <img src="/assets/images/cronoss_logo.png" width="80%">
                                </div>

                                <div class="text-center pt-4">
                                    <h1 class="h4 text-gray-900 mb-4">{{'common.auth.forgotPassword.label' | translate}}</h1>
                                </div>
                                
                                <form id="forgotForm" class="user" [formGroup]="forgotForm" autocomplete="off" (ngSubmit)="forgot()" >
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
                                        <label for="user">{{'entity.user.field.userName.label' | translate}}</label>
                                            <div class="input-group">
                                            <input 
                                                type="text" 
                                                id="userName" 
                                                formControlName="userName" 
                                                autocomplete="off" 
                                                (keydown.space)="$event.preventDefault();"
                                                placeholder="{{'entity.user.field.userName.placeHolder' | translate}}" 
                                                class="form-control form-control-user" 
                                            />
                                            </div>
                                            <app-form-error [form]="forgotForm" controlName="userName" [required]="true"></app-form-error>
                                        </div>
                                    </div>
                                    <div class="row">
                                        <div class="col-sm-12 col-md-12 col-lg-12 col-xl-12 my-3">
                                            <label for="email">{{'Email' | translate}}</label>
                                            <div class="input-group">
                                                <input 
                                                    type="email" 
                                                    id="email" 
                                                    formControlName="email" 
                                                    autocomplete="off" 
                                                    placeholder="{{'common.auth.forgotPassword.item.email.placeHolder' | translate}}" 
                                                    class="form-control form-control-user" 
                                                    aria-describedby="inputGroupPrepend"
                                                />
                                            
                                            </div>
                                            <app-form-error [form]="forgotForm" controlName="email" [required]="true" [email]="true"></app-form-error>
                                        </div>
                                    </div>
                                    <button id="forgotPasswordButton" class="btn btn-primary btn-user btn-block" type="submit" [disabled]="forgotForm.invalid" #forgotButton>
                                        {{'common.auth.forgotPassword.submit' | translate}}
                                    </button>
                                </form>
                                <hr>
                                <div class="text-center">
                                    <a class="small" routerLink="/login" routerLinkActive="active">{{'Volver al login' | translate}}</a>
                                </div>

                                <!-- <div id="invalid-user" *ngIf="errorCode !== ''" class="invalid-feedback  d-block">{{errorCode | translate}}</div> -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>

